import { useState, useEffect, useMemo } from "react";
import {
  Box,
  CircularProgress,
  CircularProgressProps,
  Typography,
} from "@mui/material";

import { useQueryCountMyTrades } from "../../graphql/apollo/useQuery";
import { TimerRange } from "../../types/models/AssetSymbol";
import { convertTimerRangeToSeconds } from "../../utils/tradeUtils";

const TimerWidget = (
  props: CircularProgressProps & {
    value: number;
    refetchTimers?: () => void;
    timerRange: TimerRange;
  }
) => {
  const { refetch: refetchMyTrades } = useQueryCountMyTrades();
  const calculateTimeLeft = (): {
    minutes: number;
    seconds: number;
  } => {
    const difference = +new Date(props.value) - +new Date();
    let minutes: number = 0;
    let seconds: number = 0;

    if (difference > 0) {
      minutes = Math.floor((difference / 1000 / 60) % 60);
      seconds = Math.floor((difference / 1000) % 60);
    }

    return { minutes, seconds };
  };
  const countdowns = calculateTimeLeft();

  if (countdowns.minutes <= 0 && countdowns.seconds <= 0) {
    props.refetchTimers && props.refetchTimers();
    refetchMyTrades();
  }

  const [timeLeft, setTimeLeft] = useState<number>(props.value);

  useEffect(() => {
    if (timeLeft === 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [props.refetchTimers, timeLeft]);

  const [progress, setProgress] = useState(100);
  const closingTime = useMemo(() => new Date(props.value), [props.value]);
  // const [countdown, setCountdown] = useState({ minutes: 0, seconds: 0 });

  useEffect(() => {
    const totalTime = convertTimerRangeToSeconds(props.timerRange); // Total duration is one minute (60,000 milliseconds)

    const calculateProgress = () => {
      const now = new Date();

      const remainingTime = closingTime.getTime() - now.getTime();
      const percentage = (remainingTime / totalTime) * 100;
      setProgress(Math.max(0, Math.min(100, percentage)));

      // const remainingSeconds = Math.max(0, Math.floor(remainingTime / 1000));
      // setCountdown({
      //   minutes: Math.floor(remainingSeconds / 60),
      //   seconds: remainingSeconds % 60,
      // });
    };

    calculateProgress();
    const interval = setInterval(calculateProgress, 1000);

    return () => clearInterval(interval);
  }, [closingTime, props.timerRange]);

  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        {...props}
        value={progress}
        color="inherit"
        sx={{ color: "white" }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption" component="div" sx={{ color: "white" }}>
          {countdowns.minutes > 0
            ? `${countdowns.minutes}m`
            : `:${countdowns.seconds}`}
        </Typography>
      </Box>
    </Box>
  );
};

export default TimerWidget;
